/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';
// import { sizeChoices } from '../helpers';

const isNotTextBlock = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TEXT_BLOCK',
]);

export default [
  ...[
    getFilterWithCol(['FieldRichText', {
      name: 'text_block_value',
      label: null,
      placeholder: 'Text Block',
      i18nTranslatable: true,
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotTextBlock, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
